import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

Vue.use(Vuex)

//モジュール定義例
/*
const otherStore = {
  namespaced: true,
  state: {
  },
  getters:{
  },
  mutations: {
  },
  actions: {
  },
}
*/

export default new Vuex.Store({
  state: {
/*共通要素*/
    siteName:'豊嶋精密工業株式会社',
		siteDomain:'toyoshimaseimitsu.co.jp',
/*ログイン*/
    idToken:'',

    pageSectionInfo:[],

/*App.vue背景制御*/
    pageBackgroundStyle:'appBackgroundBase',
/*ページ内スクロール＆アニメーション制御用*/
		scrollStatus:"",  //'', START, SCROLL, SCROLLED

/*外部css情報*/
		cssPage:[],

/*外部非同期読み込みjson情報*/
		originListEquipment:[],
		originListInformation:[],
		originListMaterial:[],
		originListProducts:[],
		originListOfficial:[],
		originListProfile:[],
		originListHistory:[],
		originListRecruit:[],
//			originListFaq:[],
		originListSEO:[],

/*ld+json内容読み込み*/
		ldJsonCommon:[],

//google構造化データ パンくず用
		ldJsonBreadcrumb:'',

/*head情報*/
		currentTitle:'',
		currentDescription:'',
		currentKeywords:'',
		currentOgUrl:'',
    currentOgType:'website',
		currentOgDesc:'',
		currentOgSite:'豊嶋精密工業株式会社オフィシャルサイト',
		currentOgImage:'https://toyoshimaseimitsu.co.jp/asset/images/ogp/hp-thumb.png',
		linkCanonical:'',
  },
  getters:{
/*
・評価値がキャッシュされる
・依存ステートが更新されるまで再評価しない
・store.getters.xx
*/
    siteName:state => state.siteName,
    siteDomain:state => state.siteDomain,
    idToken:state => state.idToken,
    pageSectionInfo:state => state.pageSectionInfo,
    pageBackgroundStyle:state => state.pageBackgroundStyle,

    scrollStatus:state => state.scrollStatus,

//google構造化データ パンくず用
		ldJsonBreadcrumb:state => state.ldJsonBreadcrumb,

/*外部css情報*/
		cssPage:state => state.cssPage,
/*外部非同期読み込みld+json情報*/
		ldJsonCommon:state => state.ldJsonCommon,
/*外部非同期読み込みjson情報*/
		originListEquipment:state => state.originListEquipment,
		originListInformation:state => state.originListInformation,
		originListMaterial:state => state.originListMaterial,
		originListProducts:state => state.originListProducts,
		originListOfficial:state => state.originListOfficial,
		originListProfile:state => state.originListProfile,
		originListHistory:state => state.originListHistory,
		originListRecruit:state => state.originListRecruit,
		originListSEO:state => state.originListSEO,

/*head用情報*/
		currentTitle:state => state.currentTitle,
		currentDescription:state => state.currentDescription,
		currentKeywords:state => state.currentKeywords,
		currentOgUrl:state => state.currentOgUrl,
		currentOgType:state => state.currentOgType,
		currentOgDesc:state => state.currentOgDesc,
		currentOgSite:state => state.currentOgSite,
		currentOgImage:state => state.currentOgImage,
		linkCanonical:state => state.linkCanonical,
  },
  mutations: {
/*
・ステートを更新するために使用
・同期処理のみ
・store.commit(xx, ww)
・定義の引数はfunction(state){}とする
*/
     updateIdToken(state, idToken) { 
      state.idToken = idToken
    },
    updatePageSectionInfo(state, pageSectionInfo) {
      state.pageSectionInfo = pageSectionInfo
    },
    updatePageBackgroundStyle(state, pageBackgroundStyle) {
      state.pageBackgroundStyle = pageBackgroundStyle
    },
/*ページ内スクロール＆アニメーション制御用*/
    updateScrollStatus(state, scrollStatus) {
      state.scrollStatus = scrollStatus
    },
/*google構造化データ パンくず用*/
		updateLdJsonBreadcrumb(state, ldJsonBreadcrumb) {
			state.ldJsonBreadcrumb = ldJsonBreadcrumb
		},

/*外部css情報*/
		updateCssPage(state, payload) {
			state.cssPage = payload.data
		},
/*外部非同期読み込みld+json情報*/
		updateLdJsonCommon(state, payload) {
			state.ldJsonCommon = payload.data
		},
/*外部非同期読み込みjson情報*/
		updateOriginListEquipment(state, payload) {
			state.originListEquipment = payload.data
		},
		updateOriginListInformation(state, payload) {
			state.originListInformation = payload.data
		},
		updateOriginListMaterial(state, payload) {
			state.originListMaterial = payload.data
		},
		updateOriginListProducts(state, payload) {
			state.originListProducts = payload.data
		},
		updateOriginListOfficial(state, payload) {
			state.originListOfficial = payload.data
		},
		updateOriginListProfile(state, payload) {
			state.originListProfile = payload.data
		},
		updateOriginListHistory(state, payload) {
			state.originListHistory = payload.data
		},
		updateOriginListRecruit(state, payload) {
			state.originListRecruit = payload.data
		},
		updateOriginListSEO(state, payload) {
			state.originListSEO = payload.data
		},

/*head用情報*/
		updateCurrentTitle(state, currentTitle) {
			state.currentTitle = currentTitle
		},
		updateCurrentDescription(state, currentDescription) {
			state.currentDescription = currentDescription
		},
		updateCurrentKeywords(state, currentKeywords) {
			state.currentKeywords = currentKeywords
		},
		updateCurrentOgUrl(state, currentOgUrl) {
			state.currentOgUrl = currentOgUrl
		},
		updateCurrentOgType(state, currentOgType) {
			state.currentOgType = currentOgType
		},
		updateCurrentOgDesc(state, currentOgDesc) {
			state.currentOgDesc = currentOgDesc
		},
		updateCurrentOgSite(state, currentOgSite) {
			state.currentOgSite = currentOgSite
		},
		updateCurrentOgImage(state, currentOgImage) {
			state.currentOgImage = currentOgImage
		},
		updateLinkCanonical(state, linkCanonical) {
			state.linkCanonical = linkCanonical
		},
  },
  actions: {
/*
・非同期処理はここで
・store.dispatch(xx)
・定義の引数はコンテキスト function(ctx){} or ({commit,}){}とする
*/
		//情報jsonデータ読み込み処理
		importJsonAsync({commit}, payload)  {
			axios.get(payload.url).then((response) => {
				commit(payload.list, {data: response.data})
//console.log("loaded"+ payload.url)
			})
		},

		importTextAsync({commit}, payload)  {
			const aConfig = {
/*
headers: {
        'Content-Length': 0,
        'Content-Type': 'text/plain'
			},
responseType: "blob"
*/
			}
			axios.get(payload.url, aConfig).then((response) => {
//				let aText = Object.entries(response.data).map(x=>x.join(":")).join("\n")
				let aText = JSON.stringify(response.data)
//console.dir(aText)
				commit(payload.list, {data: aText})
//console.log("loaded"+ aText)
			})
		},



		//Scroll状態保持
    scrollStatusAsync(context, scrollStatus) {
			context.commit('updateScrollStatus', scrollStatus);
    },

  },
  modules: {
/*
・storeを分割 storeの機能全てを持ち定義可能
*/
  },
})



